import { render, staticRenderFns } from "./OtherSet.vue?vue&type=template&id=7cd79982&scoped=true"
import script from "./OtherSet.vue?vue&type=script&lang=js"
export * from "./OtherSet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cd79982",
  null
  
)

export default component.exports